import React, { Fragment, Component } from "react";
import { withTranslation } from "react-i18next";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {
  LanguageSwitcher,
  Form,
  FormNext,
  FormBack,
  FormFooter,
  FormProgress,
  GelContentContainer,
  FormHeader,
  Results,
  FormSubmit,
} from "cw-styleguide-react";
import Question from "../components/Question";
import Utility from "../utility";
import { route, routeTranslated } from "../routes";
import GaHelmet from "../components/GaHelmet";

class StepView extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.step !== prevProps.step) {

      // Set focus on the current form progress step when the step changes.
      // https://dev.azure.com/ccdg/CWO%20-%20Accessibility/_workitems/edit/14753
      this.setFocusOnCurrentFormProgressStep();
    }
  }

  setFocusOnCurrentFormProgressStep() {
    const formProgressSteps = document.querySelectorAll(
      ".form__progress > .progress__step"
    );
    const currentFormProgressStep = document.querySelector(
      `.form__progress > .progress__step[data-progress-step="${this.props.step}"]`
    );

    // Clear any tabindexes on steps.
    formProgressSteps.forEach((step) => {
      step.removeAttribute("tabindex");
    });

    // Set tabindex and focus on the current step.
    currentFormProgressStep.setAttribute("tabindex", "-1");
    currentFormProgressStep.focus();
  }

  render() {
    const mostCommonLetter = Utility.mode(this.props.answers);

    return (
      <Fragment>
        <GaHelmet>
          <title>
            {this.props.t("route_step" + this.props.step + "_title")} |{" "}
            {this.props.t("route_app_title")}
          </title>
          <meta
            name={"description"}
            content={this.props.t("app_description")}
          />
        </GaHelmet>
        <LanguageSwitcher to={routeTranslated("step" + this.props.step)} />
        <BreadcrumbsItem to={route("step" + this.props.step)}>
          {this.props.t("route_step" + this.props.step + "_title")}
        </BreadcrumbsItem>
        <GelContentContainer>
          <h1>{this.props.t("steps.title")}</h1>
          <Form multi={true} theme={["no-padding", "no-background"]}>
            <FormProgress
              steps={[
                {
                  title: this.props.t("route_step1_title"),
                  to: route("step1"),
                  buttonTitle: this.props.t("route_step1_title"),
                  step: 1,
                },
                {
                  title: this.props.t("route_step2_title"),
                  to: route("step2"),
                  buttonTitle: this.props.t("route_step2_title"),
                  step: 2,
                },
                {
                  title: this.props.t("route_step3_title"),
                  to: route("step3"),
                  buttonTitle: this.props.t("route_step3_title"),
                  step: 3,
                },
                {
                  title: this.props.t("route_step4_title"),
                  to: route("step4"),
                  buttonTitle: this.props.t("route_step4_title"),
                  step: 4,
                },
                {
                  title: this.props.t("route_results_title"),
                  to: route("result", {
                    tab: this.props.t("results.tabs.personality.slug"),
                  }),
                  buttonTitle: this.props.t("route_results_title"),
                  step: 5,
                },
              ]}
            />
            <FormHeader>
              <FormBack theme={["secondary"]} url={this.props.previousStep} />
            </FormHeader>
            <Question
              step={this.props.step}
              question={this.props.question}
              questionIndex={this.props.questionIndex}
              answers={this.props.answers}
              setAnswers={this.props.setAnswers}
              isValid={this.props.isValid}
            />
            <FormFooter>
              <FormBack
                url={this.props.previousStep}
                title={this.props.t("steps.back")}
              />
              {this.props.isLastStep ? (
                <FormSubmit
                  title={this.props.t("styleguide:forms.submit")}
                  url={this.props.nextStep}
                  disabled={!this.props.validate(this.props.answers)}
                >
                  {this.props.t("styleguide:forms.submit")}
                </FormSubmit>
              ) : (
                <FormNext
                  url={this.props.nextStep}
                  disabled={!this.props.validate(this.props.answers)}
                />
              )}
            </FormFooter>
            <Results
              outcomes={[
                {
                  title:
                    this.props.question.results[this.props.question.codes[0]]
                      .title,
                  subTitle:
                    this.props.question.results[this.props.question.codes[0]]
                      .subtitle,
                  available:
                    this.props.validate(this.props.answers) &&
                    mostCommonLetter === this.props.question.codes[0],
                  lists:
                    this.props.question.results[this.props.question.codes[0]]
                      .list,
                },
                {
                  title:
                    this.props.question.results[this.props.question.codes[1]]
                      .title,
                  subTitle:
                    this.props.question.results[this.props.question.codes[1]]
                      .subtitle,
                  available:
                    this.props.validate(this.props.answers) &&
                    mostCommonLetter === this.props.question.codes[1],
                  lists:
                    this.props.question.results[this.props.question.codes[1]]
                      .list,
                },
              ]}
            />
          </Form>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation("local")(StepView);
